// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1SgMK","contained":"OpenButton_contained__10Bv3","disabled":"OpenButton_disabled__3UrVD","error":"OpenButton_error__2MtnV"};